// extracted by mini-css-extract-plugin
export var avatar = "_o7-3";
export var avatarContainer = "_o7-2";
export var avatarSpacer = "_o7-5";
export var avatarSpacerContainer = "_o7-4";
export var avatarStackContainer = "_o7-1";
export var bubble = "_o7-0";
export var remainderBubble = "_o7-6";